import { Images, CheckCircle, CalendarDays, ShieldCheck } from 'lucide-react';
import '../styles/dashboard.css';

export default function DashboardPage() {
  const today = new Date().toLocaleDateString('fr-FR');

  return (
    <div className="dashboard-page">
      <section className="dashboard-hero">
        <div>
          <p className="dashboard-kicker">Espace Client</p>
          <h1>Dashboard</h1>
          <p>
            Bienvenue sur votre espace de consultation Tunisie Telecom.
            Vous pouvez consulter les brandings validés depuis le menu à gauche.
          </p>
        </div>

        <div className="dashboard-hero-icon">
          <ShieldCheck size={42} />
        </div>
      </section>

      <section className="dashboard-stats">
        <div className="dashboard-stat-card">
          <div className="stat-icon">
            <Images size={24} />
          </div>
          <div>
            <h3>Brandings</h3>
            <p>Consultation des visites validées</p>
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="stat-icon">
            <CheckCircle size={24} />
          </div>
          <div>
            <h3>Statut</h3>
            <p>Accès lecture client</p>
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="stat-icon">
            <CalendarDays size={24} />
          </div>
          <div>
            <h3>Aujourd’hui</h3>
            <p>{today}</p>
          </div>
        </div>
      </section>

      <section className="dashboard-info-card">
        <h2>Interface de lecture</h2>
        <p>
          Cette version web est pensée pour le client 
        </p>
      </section>
    </div>
  );
}